var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, observe, action } from "mobx";
import * as SParsers from "./SportParsers";
import { ScoreboardType } from "../Constants";
var Parser = /** @class */ (function () {
    function Parser(retriever) {
        this.retriever = retriever;
        this.scoreboardType = ScoreboardType.Baseball; // change to be received from the BE once more scoreboards are implemented
        this.scoreboardData = {};
        this.backgroundImg = retriever.backgroundImg;
        this.disposeScoreboardData = function () { };
    }
    Parser.prototype.activate = function () {
        var _this = this;
        this.disposeScoreboardData = observe(this.retriever, "liveMasterEvent", function (change) {
            _this.setScoreboardData(_this.parseToModel(change.newValue));
        });
        this.retriever.activate();
    };
    Parser.prototype.deactivate = function () {
        this.retriever.deactivate();
        this.disposeScoreboardData();
    };
    Parser.prototype.setScoreboardData = function (data) {
        this.scoreboardData = data;
    };
    Parser.prototype.parseToModel = function (event) {
        var result = {};
        if (event === undefined || event.BaseballScoreBoardInfo === undefined) {
            return result;
        }
        if (typeof SParsers[this.scoreboardType] === "function") {
            result = SParsers[this.scoreboardType](event);
        }
        return result;
    };
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Parser.prototype, "scoreboardData", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "setScoreboardData", null);
    return Parser;
}());
export { Parser };
//# sourceMappingURL=Parser.js.map